import { LOCALE } from '~/settings/localeSetting'

export const state = () => ({
  locales: [],
  locale: LOCALE.ZH_CN,
  langIdData: {}
})

export const mutations = {
  SET_LANG(state, locale) {
    state.locale = locale
  },

  SET_LANG_DATA(state, payload) {
    state.langIdData = payload
  },
}
